/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'AiMessage'>;
const hooks = useModelQueries(schema, 'AiMessage');

export const useAggregateAiMessage: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountAiMessage: Hooks['useCount'] = hooks.useCount;
export const useCreateAiMessage: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyAiMessage: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnAiMessage: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteAiMessage: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyAiMessage: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsAiMessage: Hooks['useExists'] = hooks.useExists;
export const useFindFirstAiMessage: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyAiMessage: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueAiMessage: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByAiMessage: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyAiMessage: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateAiMessage: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountAiMessage: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstAiMessage: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyAiMessage: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueAiMessage: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByAiMessage: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyAiMessage: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateAiMessage: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyAiMessage: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnAiMessage: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertAiMessage: Hooks['useUpsert'] = hooks.useUpsert;
